import { IGetAllIndiceReajusteUseCase } from "../../../presentation/useCases/read/get_all_indice_reajuste_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IndiceReajuste } from "../../models/indice_reajuste";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetAllIndiceReajusteUseCase
 */

export class GetAllIndiceReajusteUseCase extends BasePaginatedUseCase<IndiceReajuste> implements IGetAllIndiceReajusteUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }


  async getAllIndiceReajuste(
    idsIndiceReajuste: number[],
    codigo: number | undefined,
    currentPage: number,
    rowsPerPage: number
  ): Promise<void> {
    const response = await this.repository.getAllIndiceReajusteLista(
      idsIndiceReajuste,
      codigo,
      currentPage,
      rowsPerPage);

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;

  }
}
